import { useState, useEffect, useCallback } from 'react';

export const useLoadingManager = () => {
  const [loadingState, setLoadingState] = useState({
    isOpen: false,
    currentStep: 1,
    progressValue: undefined,
    additionalText: '',
    loadingSteps: [
      { step: 1, description: 'Checking authentication...' },
      { step: 2, description: 'Loading user data...' },
      { step: 3, description: 'Fetching user role...' },
      { step: 4, description: 'Preparing workspace...' },
    ],
  });

  const startLoading = useCallback((customSteps) => {
    setLoadingState(prev => ({
      ...prev,
      isOpen: true,
      currentStep: 1,
      progressValue: undefined,
      loadingSteps: customSteps || prev.loadingSteps,
      additionalText: '',
    }));
  }, []);

  const updateStep = useCallback((step, description) => {
    setLoadingState(prev => ({
      ...prev,
      currentStep: step,
      additionalText: description || '',
    }));
  }, []);

  const updateProgress = useCallback((value, description) => {
    setLoadingState(prev => ({
      ...prev,
      progressValue: value,
      additionalText: description || prev.additionalText,
    }));
  }, []);

  const setAdditionalText = useCallback((text) => {
    setLoadingState(prev => ({
      ...prev,
      additionalText: text,
    }));
  }, []);

  const completeLoading = useCallback(() => {
    setLoadingState(prev => ({
      ...prev,
      isOpen: false,
      currentStep: 1,
      progressValue: 100,
    }));
  }, []);

  const nextStep = useCallback(() => {
    setLoadingState(prev => ({
      ...prev,
      currentStep: Math.min(prev.currentStep + 1, prev.loadingSteps.length),
    }));
  }, []);

  const setError = useCallback((errorMessage) => {
    setLoadingState(prev => ({
      ...prev,
      additionalText: `Error: ${errorMessage}`,
      progressValue: 0,
    }));
  }, []);

  return {
    loadingState,
    startLoading,
    updateStep,
    updateProgress,
    setAdditionalText,
    completeLoading,
    nextStep,
    setError,
  };
};